import styles from "./styles.module.scss";

export const TwoColumnCard = ({ title, subtitle, image, link, className = "" }) => {
  return (
    <a
      href={link}
      className={`${styles.cardWrapper} ${className}`}
      data-sourceflow-prop="link"
      data-sourceflow-content-id=""
    >
      <div
        className={styles.imageColumn}
        style={{ backgroundImage: `url(${image?.url || ""})` }}
        data-sourceflow-prop="image"
      />
      <div className={styles.textColumn}>
        <h3 className={styles.title} data-sourceflow-prop="title">
          {title}
        </h3>
        <p className={styles.subtitle} data-sourceflow-prop="subtitle">
          {subtitle}
        </p>
      </div>
    </a>
  );
};

export default TwoColumnCard;
